// Utility functions for reports

export const getTotalAccessiFromData = (accessiData) => {
  if (!accessiData || typeof accessiData !== 'object') return 0;
  return Object.values(accessiData).reduce((sum, count) => sum + (count || 0), 0);
};

export const calculateMinutesFromAccessi = (accessiData, figuraProfessionale, settings) => {
  if (!settings || !settings.figure_professionali || !accessiData) return 0;
  
  const figura = settings.figure_professionali.find(f => f.nome === figuraProfessionale);
  if (!figura) return 0;
  
  let totalMinutes = 0;
  
  Object.entries(accessiData).forEach(([tipoNome, count]) => {
    const tipologia = figura.tipologie_accessi.find(t => t.nome === tipoNome);
    if (tipologia) {
      totalMinutes += tipologia.minuti * (count || 0);
    }
  });
  
  return totalMinutes;
};

export const countGiorniFromAssenze = (assenze, tipo) => {
  if (!assenze || !assenze[tipo]) return 0;
  
  // Se è un array di periodi (malattia, ferie)
  if (Array.isArray(assenze[tipo])) {
    return assenze[tipo].length;
  }
  
  // Se è un numero (permessi in ore)
  if (typeof assenze[tipo] === 'number') {
    return assenze[tipo];
  }
  
  return 0;
};

export const formatAssenzeForDisplay = (assenze) => {
  const parts = [];
  
  if (assenze.malattia && assenze.malattia.length > 0) {
    parts.push(`Malattia: ${assenze.malattia.length} periodo/i`);
  }
  
  if (assenze.ferie && assenze.ferie.length > 0) {
    parts.push(`Ferie: ${assenze.ferie.length} periodo/i`);
  }
  
  if (assenze.permesso_ore) {
    parts.push(`Permesso: ${assenze.permesso_ore}h`);
  }
  
  if (assenze.permesso_l104_ore) {
    parts.push(`L104: ${assenze.permesso_l104_ore}h`);
  }
  
  return parts.length > 0 ? parts.join(', ') : 'Nessuna';
};

export const months = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
];
